import React, { useEffect, useRef, useState } from "react"
import { Navigate } from "react-router-dom"
import { getKeycloak } from "./keycloak"

export function withAuth(Component, options = {}) {
  const { roles = [], redirectTo = "/403" } = options

  return function ProtectedComponent(props) {
    const [status, setStatus] = useState("checking") 
    // checking | allowed | forbidden

    const loginTriggered = useRef(false)

    useEffect(() => {
      const kc = getKeycloak()
      if (!kc.authenticated) {
        if (!loginTriggered.current) {
          loginTriggered.current = true
          kc.login()
        }
        return
      }

      // Store Keycloak token in localStorage for API requests
      if (kc.token) {
        localStorage.setItem('authToken', kc.token)
      }

      // Normalize all roles (realm + client) to upper-case strings
      const tokenParsed = kc.tokenParsed || {}
      const realmRoles =
        (tokenParsed.realm_access && tokenParsed.realm_access.roles) || []
      const clientId = kc.clientId
      const resourceRoles =
        (clientId &&
          tokenParsed.resource_access &&
          tokenParsed.resource_access[clientId] &&
          tokenParsed.resource_access[clientId].roles) ||
        []
      const allRoles = [...realmRoles, ...resourceRoles].map((r) =>
        String(r || "").toUpperCase()
      )

      if (roles.length > 0) {
        const requiredRoles = roles.map((r) => String(r || "").toUpperCase())
        const hasRole = requiredRoles.some((role) => allRoles.includes(role))

        if (!hasRole) {
          setStatus("forbidden")
          return
        }
      }
      setStatus("allowed")
    }, []) 

    if (status === "checking") {
      return null
    }

    if (status === "forbidden") {
      return <Navigate to={redirectTo} replace />
    }

    return <Component {...props} />
  }
}
